import Loadable, { NullLoader } from '@comeon/loadable';

// Make all the containers loadable under single chunk.

const SportsbookMyBetsPageContainer = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "sportsbook-my-bets-page" */
			'./sportsbook-my-bets-page-container'
		),
	loading: NullLoader
});

const SportsbookMyBetsOpenContainer = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "sportsbook-my-bets-page" */
			'./sportsbook-my-bets-open-container'
		),
	loading: NullLoader
});

const SportsbookMyBetsSettledContainer = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "sportsbook-my-bets-page" */
			'./sportsbook-my-bets-settled-container'
		),
	loading: NullLoader
});

export { SportsbookMyBetsPageContainer, SportsbookMyBetsOpenContainer, SportsbookMyBetsSettledContainer };
